import React from "react";
import "./RaiseRequest.css";

const RaiseRequest = () => {
  return (
    <div className="raise__request">
      <p className="rrq__heading">Can't find what you're looking for?</p>
      <div className="rrq__btn">RAISE A REQUEST</div>
      <span className="rrq__desc1">
        Raise a request to add a company that you'd wish to invest in
      </span>
      <span className="rrq__desc2">
        we are commited to find oppotunities for you
      </span>
    </div>
  );
};

export default RaiseRequest;
